/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ServizioMensaMenuType } from './servizio-mensa-menu-type';


/**
 * payload JSON di ServizioMensaMenuUpsertForm
 */
export interface ServizioMensaMenuUpsertForm { 
    tipo: ServizioMensaMenuType;
    identificativo: string;
}



